export type PillarTableFilterHiddenProps = {
  filterKey: string;
};
const PillarTableFilterHidden = ({
  filterKey,
}: PillarTableFilterHiddenProps) => {
  return null;
};

export default PillarTableFilterHidden;
